import { render, staticRenderFns } from "./hotelAllContentInfo.vue?vue&type=template&id=22369bbe&scoped=true"
import script from "./hotelAllContentInfo.vue?vue&type=script&lang=js"
export * from "./hotelAllContentInfo.vue?vue&type=script&lang=js"
import style0 from "./hotelAllContentInfo.vue?vue&type=style&index=0&id=22369bbe&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22369bbe",
  null
  
)

export default component.exports